const if_custom_functions_config = [
  {
    selector: '#managecomics-content style',
    urlMatch: '/pages/managecomics/foc',
    fn: managecomics_foc
  },
  {
    selector: '#managecomics-content #mc-tab-subscriptions',
    urlMatch: '/pages/managecomics/my_subscriptions',
    fn: managecomics_subscriptions
  },
  {
    selector: '#ProductThumbs.product-single__thumbnails.flickity-enabled.is-draggable',
    urlMatch: '/products/',
    fn: match_product_carousel_thumbnails_to_dropdown
  },
  {
    selector: '#managecomics-content div.mc-section div.mc-container div.mc-product-main h4.mc-product-title',
    urlMatch: '/pages/managecomics/products?id=',
    fn: manage_comics_zoom_covers
  },
  {
    selector: '#managecomics-content a.mc-subscribe-btn.main-subscribe',
    urlMatch: '/pages/managecomics',
    fn: manage_comics_login_return_to_page
  },
  {
    // selector: '.product-gallery__media-link',
    selector: 'h1.product__title',
    urlMatch: /\/(products\/|collections\/back-issues\/products)/,
    fn: handle_products_main
  },
  {
    selector: 'div.collection__wrapper',
    urlMatch: /\/(products\/|collections\/back-issues\/products)/,
    fn: hide_prices_in_collections_list
  },
  {
    selector: 'span.text-highlight__break',
    urlMatch: '/collections/',
    fn: handle_collections_main
  }
  // {
  //   selector: 'body',
  //   urlMatch: '/collections/back-issues',
  //   fn: products_handle_back_issues_collection
  // }
  // Add more configs as needed
];

(function() {
  const intervalMs = 200;
  const timeoutMs = 10000;
  let waited = 0;
  let config = if_custom_functions_config.slice();

  check_back_issues_collection();

  const interval = setInterval(function() {
    config = config.filter(function(cfg) {
      let urlOk = true;
      if (cfg.urlMatch) {
        if (typeof cfg.urlMatch === 'string') {
          urlOk = window.location.href.includes(cfg.urlMatch);
        } else if (cfg.urlMatch instanceof RegExp) {
          urlOk = cfg.urlMatch.test(window.location.href);
        }
      }
      if (!urlOk) return true;

      const el = document.querySelector(cfg.selector);
      if (el) {
        try {
          cfg.fn(el);
        } catch(e) {
          console.error('Error in custom function:', cfg.selector, e);
        }
        return false;
      }
      return true;
    });

    if (config.length === 0) {
      clearInterval(interval);
    }

    waited += intervalMs;
    if (waited >= timeoutMs) {
      clearInterval(interval);
    }
  }, intervalMs);
})();